export const FOOTER = {
  TEXT: 'Powered by',
};
